import ApiV2 from './ApiV2';

export default class UsuarioService {
  static async getDadosPessoais(id_usuario, id_entidade) {
    return ApiV2.get('/pessoa/dados-pessoa', {
      params: {
        id_usuario,
        id_entidade,
      },
    });
  }

  static async getTelefoneTipos() {
    return ApiV2.get('/endereco/tipo-telefone');
  }
}
